export default class ComponentsPost {
    constructor() {
        const htmlModal = `
            <div class="modal-image modal-image-id">
                <div class="backshadow"></div>
                <div class="modal-content">
                    <div class="block-image">
                        <div class="close-modal">
                            <span>&#10005;</span>
                        </div>
                        <img loading="lazy" fetchpriority="low" src="" />
                    </div>
                </div>
            </div>
        `
        document.body.insertAdjacentHTML('beforeend', htmlModal)

        let elImageModal = document.querySelector('.modal-image')
        let modalImage = elImageModal.querySelector('img')
        let elCloseModal = elImageModal.querySelectorAll('.backshadow, .close-modal')

        let imageFull = document.querySelectorAll('.article-post .size-full')

        if(imageFull){
            imageFull.forEach(function (image) {
                let picture = image.closest("picture")

                if(picture){
                    picture.setAttribute('data-imagesrc', image.src)
        
                    picture.addEventListener('click', function (event) {
                        event.preventDefault()
        
                        modalImage.src = image.src
                        elImageModal.classList.add('show')
                        document.body.classList.add('no-scroll')
                    })
                }
    
            })
        }

        elCloseModal.forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault()
                elImageModal.classList.remove('show')
                document.body.classList.remove('no-scroll')
                modalImage.src = ''
            })
        })

        
        let headerListComments = document.querySelectorAll('.header-list-comments')
        let listComments = document.querySelector('.list-comments')

        if(headerListComments){
            headerListComments.forEach(el => {
                el.addEventListener('click', function (event) {
                    listComments.classList.toggle('active')                
                })
            })
        }

        let submitBtn = document.querySelector('#submit')

        if(submitBtn){
            submitBtn.value = 'Enviar'
        }


        // Função para converter a data e hora em um formato numérico para facilitar a comparação
        function convertToNumeric(dateTimeString) {
            let parts = dateTimeString.split(" às ");
            let datePart = parts[0].split("/");
            let timePart = parts[1].split(":");
            
            // Adicionando zeros à esquerda para garantir que os números tenham dois dígitos
            let formattedDate = datePart[2] + datePart[1].padStart(2, '0') + datePart[0].padStart(2, '0');
            let formattedTime = timePart[0].padStart(2, '0') + timePart[1].padStart(2, '0');

            return parseInt(formattedDate + formattedTime)
        }

        // Função para ordenar por data e hora
        function sortByDateTime(comments, order) {
            
            comments.sort(function(a, b) {
                let dateA = convertToNumeric(a.querySelector('.commentmetadata a').textContent);
                let dateB = convertToNumeric(b.querySelector('.commentmetadata a').textContent);
                return order === '1' ? dateB - dateA : dateA - dateB;
            });
        }

        // Função para ordenar por estrelas (relevância)
        function sortByStars(comments) {
            comments.sort(function(a, b) {
                let starsA = parseInt(a.querySelector('.stars').dataset.rating);
                let starsB = parseInt(b.querySelector('.stars').dataset.rating);
                return starsB - starsA;
            });
        }

        // Função para aplicar a ordenação com base na opção selecionada
        function sortComments() {
            let orderSelect = document.getElementById('order-comments');
            let orderValue = orderSelect.options[orderSelect.selectedIndex].value;
        
            let commentsList = document.querySelector('.list-comments-ul');
            let comments = Array.from(commentsList.children);

            console.log(comments)
        
            if (orderValue === '1' || orderValue === '2') {
                sortByDateTime(comments, orderValue);
            } else if (orderValue === '3') {
                sortByStars(comments);
            }
        
            // Remover todos os elementos da lista no DOM
            while (commentsList.firstChild) {
                commentsList.removeChild(commentsList.firstChild);
            }
        
            // Adicionar os elementos ordenados de volta ao DOM
            comments.forEach(function(comment) {
                commentsList.appendChild(comment);
            });
        }
        
        // Adicionar um ouvinte de evento para o select
        let orderSelect = document.getElementById('order-comments');
        if(orderSelect){
            orderSelect.addEventListener('change', sortComments);
        }
    }
}